var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import styles from './Button.module.scss';
import classNames from 'classnames';
import ButtonBase from '../ButtonBase/ButtonBase';
import Loader from '../Loader/Loader';
export const Button = React.forwardRef((_a, ref) => {
    var { className, children, to, onClick, loading = false, variant, condensed = 'none', flexible = false, endIcon, alignStart = false, textSize = 'normal' } = _a, props = __rest(_a, ["className", "children", "to", "onClick", "loading", "variant", "condensed", "flexible", "endIcon", "alignStart", "textSize"]);
    const renderEndIcon = useMemo(() => {
        if (!endIcon) {
            return null;
        }
        return _jsx("div", Object.assign({ className: styles.endIconWrapper }, { children: endIcon }));
    }, [endIcon]);
    return (_jsx(ButtonBase, Object.assign({ className: classNames(styles.button, className, {
            [styles.buttonPrimary]: variant === 'primary',
            [styles.buttonSecondary]: variant === 'secondary',
            [styles.buttonDanger]: variant === 'danger',
            [styles.buttonSuccess]: variant === 'success',
            [styles.buttonCondensedAll]: condensed === 'all',
            [styles.buttonCondensedHorizontal]: condensed === 'horizontal',
            [styles.buttonDisabled]: props.disabled,
            [styles.buttonFlexible]: flexible,
            [styles.buttonAlignStart]: alignStart,
            [styles.buttonTextSizeSmall]: textSize === 'small',
        }), to: to, onClick: onClick, ref: ref, loading: loading }, props, { children: loading ? (_jsx(Loader, { inline: true })) : (_jsxs(_Fragment, { children: [children, renderEndIcon] })) })));
});
export default React.memo(Button);
